import { SiteRoute } from '@journeyapps/package-types';
import { faDiscord, faGithub, faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faBolt, faExternalLink, faHeadset, faPhone } from '@fortawesome/free-solid-svg-icons';
import { DOCS_NAVIGATION, DocsNavigationNode } from '@journeyapps/package-docs';
import { MenuItem } from './widgets/Menu/MenuItemWidget';
import { getDocsNodePath } from './pages/docs/shared/navigation';

const buildDocsMenuItems = (items: DocsNavigationNode[]): MenuItem[] => {
  return items.map((item) => ({
    to: getDocsNodePath(item),
    label: item.label,
    tag: item.tag
  }));
};

const docsSectionItems = buildDocsMenuItems(DOCS_NAVIGATION.items);

export const MainMenuItems: MenuItem[] = [
  {
    to: '#',
    label: 'Overview',
    items: [
      {
        to: SiteRoute.RAPID_CODE,
        label: 'Rapid-code paradigm'
      },
      {
        to: SiteRoute.FEATURES,
        label: 'Platform features'
      },
      {
        to: SiteRoute.FEATURE_FINDER,
        label: 'Help me explore'
      },
      {
        to: SiteRoute.ROADMAP,
        label: 'Roadmap'
      },
      {
        to: SiteRoute.FAQ,
        label: 'FAQ'
      }
    ]
  },
  {
    to: SiteRoute.AI,
    label: 'AI'
  },
  {
    to: SiteRoute.BLOG,
    label: 'Blog'
  },
  {
    to: '#',
    label: 'Platform stack',
    items: [
      {
        to: SiteRoute.RUNTIME_ENGINE,
        label: 'Runtime Engine'
      },
      {
        to: SiteRoute.APP_BACKEND,
        label: 'App Backend'
      },
      {
        to: SiteRoute.OXIDE,
        label: 'OXIDE'
      },
      {
        to: SiteRoute.SECTOR,
        label: 'Sector',
        tag: 'new!'
      },
      {
        to: SiteRoute.CLOUD_CODE,
        label: 'CloudCode'
      },
      // {
      //   to: SiteRoute.OPSQL,
      //   label: 'OPSQL'
      // },
      {
        to: SiteRoute.OVERRIDE,
        label: 'OVERRIDE',
        tag: 'new!'
      }
    ]
  },
  {
    to: '#',
    label: 'Documentation',
    items: [
      {
        to: SiteRoute.DOCS,
        label: 'Developer docs',
        items: docsSectionItems
      },
      {
        to: '/docs/topics/',
        label: 'Browse all topics'
      },
      {
        to: 'https://whatsnew.journeyapps.com/',
        label: 'Release notes'
      },
      {
        to: '/docs/get-started/tutorial-build-your-first-app/',
        label: 'Tutorial'
      },
      {
        to: 'https://www.udemy.com/course/journeyapps-training-foundations/',
        label: 'Free Udemy courses',
        icon: faExternalLink
      }
    ]
  },
  {
    to: '#',
    label: 'Support',
    items: [
      {
        to: 'https://discord.gg/Y6UVezgXxj',
        label: 'Discord community',
        icon: faDiscord
      },
      {
        to: 'https://support.journeyapps.com/hc/en-us/restricted?return_to=https%3A%2F%2Fsupport.journeyapps.com%2Fhc%2Fen-us',
        label: 'Support center',
        icon: faHeadset
      },
      {
        to: 'https://status.journeyapps.com',
        label: 'Status & outages',
        icon: faBolt
      },
      {
        to: 'https://journeyapps.com/contact/',
        label: 'Contact us',
        icon: faPhone
      }
    ]
  },
  {
    to: SiteRoute.PRICING,
    label: 'Pricing'
  },
  {
    to: SiteRoute.HOMEPAGE,
    label: 'Company',
    items: [
      {
        to: 'https://journeyapps.com/about-us/',
        label: 'About us'
      },
      {
        to: SiteRoute.CUSTOMERS,
        label: 'Our customers'
      },
      {
        to: 'https://journeyapps.com/join-us/',
        label: 'Join our team'
      },
      {
        to: '#',
        label: 'Socials',
        items: [
          {
            to: 'https://www.linkedin.com/company/journeyapps',
            label: 'LinkedIn',
            icon: faLinkedin
          },
          {
            to: 'https://www.youtube.com/channel/UCAeVDVRr1czY_GoxMQQerQA',
            label: 'YouTube',
            icon: faYoutube
          },
          {
            to: 'https://github.com/journeyapps',
            label: 'GitHub',
            icon: faGithub
          }
        ]
      },
      {
        to: '#',
        label: 'Legal',
        items: [
          {
            to: SiteRoute.TERMS_OF_USE,
            label: 'Terms of use'
          },
          {
            to: SiteRoute.PRIVACY_POLICY,
            label: 'Privacy policy'
          },
          {
            to: SiteRoute.DISCLAIMER,
            label: 'Disclaimer'
          },
          {
            to: SiteRoute.GDPR,
            label: 'GDPR'
          },
          {
            to: SiteRoute.SECURITY_REPORTING,
            label: 'Security reporting'
          },
          {
            to: SiteRoute.SUB_PROCESSORS,
            label: 'Sub-processors'
          }
        ]
      }
    ]
  },
  {
    to: '#',
    label: 'Other products',
    items: [
      {
        to: 'https://powersync.com',
        label: 'PowerSync'
      }
    ]
  }
];
